import {
  BarChart3,
  CalendarDays,
  CheckSquare,
  FileText,
  FlaskConical,
  LayoutDashboard,
  Megaphone,
  Plug,
  Search,
  Settings,
  Tags,
} from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Design doc §5.1, in order. Eleven destinations, no more and no fewer.
 *
 * `built: false` means the route renders an explicit "not built yet" state
 * rather than a screen wired to an endpoint that does not exist. The flag is
 * shown to the user in the navigation so nobody clicks hopefully.
 */
export interface NavItem {
  readonly id: string;
  /** i18n key under `nav.*`. */
  readonly labelKey: string;
  /** Path relative to the workspace root. */
  readonly to: string;
  readonly icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean | 'true' | 'false' }>;
  readonly built: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  {
    id: 'portfolio',
    labelKey: 'nav.portfolio',
    to: 'portfolio',
    icon: LayoutDashboard,
    built: true,
  },
  { id: 'brands', labelKey: 'nav.brands', to: 'brands', icon: Tags, built: true },
  { id: 'campaigns', labelKey: 'nav.campaigns', to: 'campaigns', icon: Megaphone, built: true },
  { id: 'content', labelKey: 'nav.content', to: 'content', icon: FileText, built: true },
  { id: 'calendar', labelKey: 'nav.calendar', to: 'calendar', icon: CalendarDays, built: true },
  { id: 'seo', labelKey: 'nav.seo', to: 'seo', icon: Search, built: true },
  {
    id: 'experiments',
    labelKey: 'nav.experiments',
    to: 'experiments',
    icon: FlaskConical,
    built: true,
  },
  { id: 'analytics', labelKey: 'nav.analytics', to: 'analytics', icon: BarChart3, built: true },
  { id: 'approvals', labelKey: 'nav.approvals', to: 'approvals', icon: CheckSquare, built: true },
  { id: 'integrations', labelKey: 'nav.integrations', to: 'integrations', icon: Plug, built: true },
  { id: 'settings', labelKey: 'nav.settings', to: 'settings', icon: Settings, built: true },
] as const;
